/* eslint-disable consistent-return */

import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import "./TransparentVideo.scss";

function TransparentVideo({
  width,
  height,
  backgroundRef,
  mp4Src,
  webmSrc,
  containerClass,
  preload,
  transparentDivStyle,
  ...rest
}) {
  const container = useRef();
  const videoRef = useRef();
  const [isLoaded, setIsLoaded] = useState(false);

  const safariAgent =
    typeof window !== "undefined" &&
    navigator?.userAgent?.search("Safari") >= 0 &&
    navigator?.userAgent?.search("Chrome") < 0;
  const videoSrc = safariAgent ? mp4Src : webmSrc || mp4Src;

  const setVideoBgColor = () => {
    const canvasBg = document.createElement("canvas");
    canvasBg.width = 8;
    canvasBg.height = 8;

    const ctxBg = canvasBg.getContext("2d");

    ctxBg.drawImage(videoRef.current, 0, 0, 8, 8);

    const p = ctxBg.getImageData(0, 0, 8, 8).data;
    if (p[60] === 0 && p[61] === 0 && p[62] === 0) return;

    const newBackgroundElement = {
      ...(backgroundRef?.current || container.current),
      style: { ...(backgroundRef?.current?.style || container.current?.style) },
    };
    newBackgroundElement.style.backgroundColor = `rgb(${p[60]},${p[61]},${p[62]})`;
  };

  useEffect(() => {
    const vid = videoRef.current;
    if (!container.current || !vid) return;

    const handleLoadedData = () => {
      setVideoBgColor();
      if (!document.hidden) videoRef.current?.play();
    };

    vid.addEventListener("loadedmetadata", () => {
      setIsLoaded(true);
    });

    vid.src = videoSrc;
    vid.load();
    if (!document.hidden)
      vid
        .play()
        .catch((error) =>
          console.error("Failed to play the video:", error.message),
        );

    return () => {
      vid.removeEventListener("loadedmetadata", handleLoadedData);
    };
  }, [videoSrc, safariAgent, backgroundRef, isLoaded]);

  return (
    <div
      className={`transparent-video video-webm ${
        containerClass || "md:mt-[0px]"
      } ${isLoaded ? "loaded" : ""} ${transparentDivStyle}`}
      ref={container}
      style={{ width, height }}>
      <video
        autoPlay
        loop
        muted
        playsInline
        ref={videoRef}
        {...rest}
        preload={preload}
        style={{ width, height }}
      />
    </div>
  );
}

TransparentVideo.defaultProps = {
  webmSrc: null,
  backgroundRef: null,
  width: null,
  height: null,
  containerClass: "",
  preload: "none",
  transparentDivStyle: "",
};

TransparentVideo.propTypes = {
  mp4Src: PropTypes.string.isRequired,
  webmSrc: PropTypes.string,
  transparentDivStyle: PropTypes.string,
  containerClass: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  backgroundRef: PropTypes.shape({ current: PropTypes.any }),
  width: PropTypes.string,
  height: PropTypes.string,
  preload: PropTypes.oneOf(["auto", "metadata", "none"]),
};

export default TransparentVideo;
